import {useCallback, useMemo} from 'react';

import {trackPanelBankEvent} from '../../../services/analytics';
import {usePanelSearchDebouncedContext} from '../../../state/panelbank/PanelSearchContextProvider';
import {useWorkspaceRefsContext} from '../../Workspace/WorkspaceRefsContext';
import {usePanelBankSectionsOpenTempContext} from '../contextProviders/PanelBankSectionsDuringSearch';

export const usePanelBankSectionsActions = () => {
  const {panelBankActions} = useWorkspaceRefsContext();

  const {openAllSectionsTemp, closeAllSectionsTemp} =
    usePanelBankSectionsOpenTempContext();

  const {isSearching} = usePanelSearchDebouncedContext();

  // Note that these functions have different behavior depending on whether or not we're searching
  const openAllSections = useCallback(() => {
    trackPanelBankEvent({action: 'Expand all sections'});
    return isSearching
      ? openAllSectionsTemp()
      : panelBankActions.openOrCloseAllSections(true);
  }, [isSearching, openAllSectionsTemp, panelBankActions]);

  const closeAllSections = useCallback(() => {
    trackPanelBankEvent({action: 'Collapse all sections'});
    return isSearching
      ? closeAllSectionsTemp()
      : panelBankActions.openOrCloseAllSections(false);
  }, [closeAllSectionsTemp, isSearching, panelBankActions]);

  return useMemo(
    () => ({openAllSections, closeAllSections}),
    [closeAllSections, openAllSections]
  );
};
